import { filterBalanceTokenSearch } from 'utils/token'
import { useFilterOptionsBySearch } from 'views/Payment/DesktopPayment/components/PaymentSelect/hooks'
import { BalanceOptionItemProps } from '../components/TokenAmountOptionItem'

export const useBalanceSearch = (displayBalanceOptions: BalanceOptionItemProps[]) => {
  const { onChange, options, typedValue } = useFilterOptionsBySearch({
    options: displayBalanceOptions,
    filterFn: filterBalanceTokenSearch,
  })

  return {
    onChange,
    typedValue,
    filteredDisplayOptions: options,
  }
}
